import { Stack, useRouter, useNavigation } from "expo-router";
import { Pressable } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { useThemeColors } from "@/providers/ThemeProvider";

/**
 * Teams management stack layout for familie admins
 */
export default function TeamsLayout() {
  const router = useRouter();
  const navigation = useNavigation();
  const colors = useThemeColors();

  /**
   * Handle back navigation safely
   * If there's no screen to go back to, navigate to admin tab
   */
  const handleBack = () => {
    if (navigation.canGoBack()) {
      router.back();
    } else {
      // No screen to go back to, navigate to admin tab
      router.replace("/(tabs)/admin");
    }
  };

  return (
    <Stack
      screenOptions={{
        headerShown: true,
        headerStyle: { backgroundColor: colors.surface },
        headerTintColor: "#D97706",
        headerTitleStyle: { color: colors.text },
        headerLeft: () => (
          <Pressable onPress={handleBack} className="mr-2">
            <Ionicons name="arrow-back" size={24} color="#D97706" />
          </Pressable>
        ),
      }}
    >
      <Stack.Screen
        name="index"
        options={{ title: "Teams Beheren" }}
      />
      <Stack.Screen
        name="create"
        options={{ title: "Nieuw Team" }}
      />
      <Stack.Screen
        name="[id]"
        options={{ title: "Team Bewerken" }}
      />
      <Stack.Screen
        name="members/[id]"
        options={{ title: "Leden Beheren" }}
      />
    </Stack>
  );
}
